let list = [];
let json;

try {
    json = localStorage.getItem('user');
} catch (error) {
    console.log(error)
}
const user = json !== 'undefined' && json ? JSON.parse(json) : null;

if(localStorage.getItem('EquipamentDataList') && typeof(JSON.parse(localStorage.getItem('EquipamentDataList'))) === 'object'){
    list = JSON.parse(localStorage.getItem('EquipamentDataList'))
}

const InitialMapState = {
    isLoadingModal : true,
    showCaption: false,
    equipamento: {
        nome: '',
        id: '',
    },
    dados: [],
    state: '',
    Buttons: {
        dash:   false,
        control: false
    },
    EquipamentDataList: list,
    checkedTutorial: user?.user?.checkedTutorial,
}

export default function mapReducer ( PrevState = InitialMapState, action){
    switch (action.type) {
        case 'ChangeMapLoading':
            return{
                ...PrevState,
                isLoadingModal : action.payload.loading
            };
        case 'ChangeMapShowCaption':
            return{
                ...PrevState,
                showCaption : action.payload.showCaption
            };
        case 'ChangeMapEquipment':
            return{
                ...PrevState,
                equipamento : action.payload.equipamento
            };
        case 'ChangeMapData':
            return{
                ...PrevState,
                dados : action.payload.data
            };
        case 'ChangeMapState':
            return{
                ...PrevState,
                state : action.payload.state
            };
        case 'ChangeButtonsMap':
            return{
                ...PrevState,
                Buttons : action.payload.Buttons
            };
        case 'ChangeEquipamentDataList':
            localStorage.setItem('EquipamentDataList', JSON.stringify(action.payload.data));
            return{
                ...PrevState,
                EquipamentDataList : action.payload.data
            };
        case 'ChangeCheckedTutorial':
            return {
                ...PrevState,
                checkedTutorial: action.payload.checkedTutorial,
            };
        default:
            return PrevState;
    }
}